export default "__VITE_ASSET__CpP3GSkZ__"